import { render, staticRenderFns } from "./collegeCopy.vue?vue&type=template&id=318adca7&scoped=true&"
import script from "./collegeCopy.vue?vue&type=script&lang=js&"
export * from "./collegeCopy.vue?vue&type=script&lang=js&"
import style0 from "./collegeCopy.vue?vue&type=style&index=0&id=318adca7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318adca7",
  null
  
)

export default component.exports